import { Row, Input, Col, Form } from "antd";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { formatUsername } from "utils/formatUsername";

interface OrderPartyProps {
  data: API_UserContactData;
}
export const OrderParty = observer(({ data }: OrderPartyProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  return (
    <Row justify="start" align="middle" gutter={24}>
      <Col span={12}>
        <Form.Item
          label={t("Customer number")}
          name={["orderParty", "contactId"]}
          initialValue={""}
          rules={[
            {
              max: 20,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("Contact person")}
          name={["orderParty", "name"]}
          initialValue={`${formatUsername({ firstName: data.firstname, surname: data.surname })}` || ""}
          rules={[
            {
              max: 200,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("Company")}
          name={["orderParty", "companyName"]}
          initialValue={data.companyName || ""}
          rules={[
            {
              max: 200,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("Street")}
          name={["orderParty", "street"]}
          initialValue={data.street || ""}
          rules={[
            {
              max: 200,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("Post code")}
          name={["orderParty", "postalCode"]}
          initialValue={data.postalCode || ""}
          rules={[
            {
              max: 20,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("City")}
          name={["orderParty", "city"]}
          initialValue={data.city || ""}
          rules={[
            {
              max: 200,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("Phone")}
          name={["orderParty", "phoneNumber"]}
          initialValue={data.phoneNumber || ""}
          rules={[
            {
              max: 50,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("Mobile")}
          name={["orderParty", "mobileNumber"]}
          initialValue={data.mobileNumber || ""}
          rules={[
            {
              max: 50,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("Fax")}
          name={["orderParty", "fax"]}
          initialValue={data.fax || ""}
          rules={[
            {
              max: 50,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={t("Email")}
          name={["orderParty", "email"]}
          initialValue={data.email || ""}
          rules={[
            {
              max: 60,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label={t("Purpose of use")}
          name={["orderParty", "purpose"]}
          initialValue={""}
          rules={[
            {
              max: 1000,
              message: t("Maximum length reached"),
            },
          ]}
          validateTrigger={["onChange", "onBlur"]}
        >
          <Input.TextArea
            rows={2}
            placeholder={t("Specify the purpose of use")}
            style={{ border: "1px solid #e4e4e4", padding: "10px" }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
});
